import { Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { isValidCnpj } from '../utils/cnpj.util';

export const EmailValidator = [
  Validators.required,
  Validators.pattern('.*\\S.*'),
  Validators.minLength(5),
  Validators.maxLength(254),
  Validators.email,
];

export const RequiredValidator = [
  Validators.required,
  Validators.minLength(1),
  Validators.pattern('.*\\S.*'),
];

export const PostalCodeValidator = [
  Validators.required,
  Validators.minLength(8),
  Validators.maxLength(9),
];

export function cnpjValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value;
  if (value === null || value === undefined || value === '') return null;
  return isValidCnpj(value) ? null : { invalidCnpj: true };
}

export function noWhitespaceValidator(
  control: AbstractControl
): ValidationErrors | null {
  const value = control.value || '';
  const isOnlyWhitespace =
    typeof value === 'string' && value.trim().length === 0;
  return isOnlyWhitespace ? { whitespace: true } : null;
}
